<template>
    <div ref="breadcrumb" class="breadcrumb" data-cy="breadcrumb">
        <ul class="breadcrumb__list" :class="{ multilevel: items.length > 1, lastHide: lastHide }">
            <li v-if="showHome" class="breadcrumb__item">
                <a href="/" tabindex="-1" :title="$t('mainTitle')" class="d-flex align-items-center">
                    <img src="/nuxt-assets/design2025/icons/home.svg" />
                </a>
            </li>

            <template v-for="(item, index) in items" :key="index">
                <li
                    v-if="item.title !== productName"
                    class="breadcrumb__item"
                    :class="{ 'breadcrumb__item--link': item.url, 'breadcrumb__item--not-link': !item.url }"
                >
                    <i v-if="index !== 0 || showHome" class="breadcrumb__arrow"></i>
                    <nuxt-link v-if="item.url" :to="item.url" class="breadcrumb__link" data-cy="breadcrumb-link">{{
                        item.title
                    }}</nuxt-link>
                    <span v-else class="breadcrumb__name">{{ item.title }}</span>
                </li>
            </template>
        </ul>
    </div>
</template>
<script lang="ts">
import BreadcrumbItem from '~/models/BreadcrumbItem'

export default {
    props: {
        items: {
            type: Array as PropType<BreadcrumbItem[]>,
            required: true,
        },
        lastHide: {
            type: Boolean,
            default: false,
        },
        productName: {
            type: String,
            default: '',
        },
        showHome: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        setTimeout(() => {
            this.scrollBreadcrumb()
        }, 0)
    },
    methods: {
        scrollBreadcrumb() {
            if (!this.$refs.breadcrumb) {
                return
            }

            this.$refs.breadcrumb.scrollTo({
                left: 1000,
                behavior: 'auto',
            })
        },
    },
}
</script>
<style lang="scss" scoped>
.breadcrumb {
    overflow-y: hidden;
    overflow-x: auto;
    width: calc(100% + 15px);
    margin-left: -15px;
    position: relative;
    margin-bottom: 1rem;
    margin-top: 1rem;
    padding: 0 15px;
}

.breadcrumb__list {
    list-style-type: none;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
    align-content: center;
}

.breadcrumb__item {
    display: flex;
    align-items: center;
    align-content: center;
    flex-shrink: 0;
}

.breadcrumb__item::before {
    display: none;
}

.breadcrumb__arrow {
    background: transparent url('/nuxt-assets/icons/breadcrumb-arrow.svg') no-repeat scroll 0 0;
    background-size: cover;
    width: 6px;
    height: 10px;
    display: inline-block;
    margin-left: 11px;
    margin-right: 11px;

    @include screen-md {
        transform: rotate(0deg);
        margin-left: 11px;
    }
}

.breadcrumb__link {
    font-size: 14px;
    line-height: 30px;
    color: #31a993;
    text-decoration: underline;
    white-space: nowrap;

    &:hover {
        text-decoration: none;
    }

    .ico {
        margin: 3px 4px 0 0;
    }
}

.breadcrumb__name {
    color: $color-primary-green;
    font-size: 14px;
    white-space: nowrap;
}
</style>
